export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/power_bi.ebd3873.svg";